export const COMMON = {
  SITE_NAME: 'COMMON_COMMON_SITE_NAME',
  FR: 'COMMON_COMMON_FR',
  EN: 'COMMON_COMMON_EN',
  PAGE_TOP: 'COMMON_COMMON_PAGE_TOP',
  LISTEN: 'COMMON_COMMON_LISTEN',
  VIEW_MORE: 'COMMON_COMMON_VIEW_MORE',
  SEND_EMAIL: 'COMMON_COMMON_SEND_EMAIL',
  VALIDATE: 'COMMON_COMMON_VALIDATE',
  BREADCRUMB_HOME: 'COMMON_COMMON_BREADCRUMB_HOME',
  FILTER_SEARCH_LABEL: 'COMMON_COMMON_FILTER_SEARCH_LABEL',
  FILTER_SEARCH_PLACEHOLDER: 'COMMON_COMMON_FILTER_SEARCH_PLACEHOLDER',
  PUBLISHED_AT: 'COMMON_COMMON_PUBLISHED_AT',
  UPDATED_AT: 'COMMON_COMMON_UPDATED_AT',
  RELATED_ARTICLES: 'COMMON_COMMON_RELATED_ARTICLES',
  SHOW_VIDEO: 'COMMON_COMMON_SHOW_VIDEO',
  SUMMARY_TO_CONVINCE: 'COMMON_COMMON_SUMMARY_TO_CONVINCE',
  TERRITORY_NATIONAL: 'COMMON_COMMON_TERRITORY_NATIONAL',
  TERRITORY_REGIONAL: 'COMMON_COMMON_TERRITORY_REGIONAL',
  TRANSCRIPT: 'COMMON_COMMON_TRANSCRIPT',
  READ_TRANSCRIPT: 'COMMON_COMMON_READ_TRANSCRIPT',
  VIEW_ALL_PUSHS: 'COMMON_COMMON_VIEW_ALL_PUSHS',
  VIEW_CARD: 'COMMON_COMMON_VIEW_CARD',
  VIEW_WEBSITE: 'COMMON_COMMON_VIEW_WEBSITE',
  CLOSE_POPOVER: 'COMMON_COMMON_CLOSE_POPOVER',
  CONTACT_REGIONS_SELECT_LABEL: 'COMMON_COMMON_CONTACT_REGIONS_SELECT_LABEL',
  GO_TO_RELATED_ARTICLE: 'COMMON_COMMON_GO_TO_RELATED_ARTICLE',
  MORE_INFORMATION: 'COMMON_COMMON_MORE_INFORMATION',
  DOWNLOAD: 'COMMON_COMMON_DOWNLOAD',
  DOWNLOAD_THE_DOCUMENT: 'COMMON_COMMON_DOWNLOAD_THE_DOCUMENT',
  DOWNLOAD_PUBLICATION: 'COMMON_COMMON_DOWNLOAD_PUBLICATION',
  READ_MORE: 'COMMON_COMMON_READ_MORE',
  PRESS_RELEASE_READ: 'COMMON_COMMON_PRESS_RELEASE_READ',
  PHOTOS_CREDITS: 'COMMON_COMMON_PHOTOS_CREDITS',

  ERROR_LINK_TO_HOME: 'COMMON_ERROR_LINK_TO_HOME',
  ERROR_DEFAULT: 'COMMON_ERROR_DEFAULT',
  ERROR_NOT_FOUND: 'COMMON_ERROR_NOT_FOUND',
  ERROR_LOADING_DOC: 'COMMON_ERROR_LOADING_DOC',
  ERROR_LOADING_DOC_BY_ID: 'COMMON_ERROR_LOADING_DOC_BY_ID',
  ERROR_LOADING_DOC_BY_UID: 'COMMON_ERROR_LOADING_DOC_BY_UID',
  ERROR_LOADING_SINGLE_TYPE_DOC: 'COMMON_ERROR_LOADING_SINGLE_TYPE_DOC',
  ERROR_LOADING_MORE: 'COMMON_ERROR_LOADING_MORE',
  ERROR_FETCHING_BACKEND: 'COMMON_ERROR_FETCHING_BACKEND',
  ERROR_CONVERTING_DOC: 'COMMON_ERROR_CONVERTING_DOC',
  ERROR_VALIDATING_DOC: 'COMMON_ERROR_VALIDATING_DOC',
  ERROR_MAINTENANCE_SITE: 'COMMON_ERROR_MAINTENANCE_SITE',
  ERROR_MAINTENANCE_PAGE: 'COMMON_ERROR_MAINTENANCE_PAGE',
  ERROR_BACK_TO_HOME: 'COMMON_ERROR_BACK_TO_HOME',

  DATE_DAY_MONTH_YEAR_FORMAT: 'COMMON_DATE_DAY_MONTH_YEAR_FORMAT',
  DATE_DAY_MONTH_FORMAT: 'COMMON_DATE_DAY_MONTH_FORMAT',
  DATE_DAY_FORMAT: 'COMMON_DATE_DAY_FORMAT',
  DATE_HOUR_FORMAT: 'COMMON_DATE_HOUR_FORMAT',
  DATE_FROM_TO_SAME_MONTH_DAY: 'COMMON_DATE_FROM_TO_SAME_MONTH_DAY',
  DATE_FROM_TO_SAME_MONTH: 'COMMON_DATE_FROM_TO_SAME_MONTH',
  DATE_FROM_TO_SAME_YEAR: 'COMMON_DATE_FROM_TO_SAME_YEAR',
  DATE_FROM_TO: 'COMMON_DATE_FROM_TO',
  DATE_FROM_DATE_TIME: 'COMMON_DATE_FROM_DATE_TIME',
  DATE_FROM_DATE: 'COMMON_DATE_FROM_DATE',

  PROFILE_POPUP_CONTACT_TITLE: 'COMMON_PROFIL_POPUP_CONTACT_TITLE',
  PROFILE_POPUP_CONTACT_EMAIL: 'COMMON_PROFIL_POPUP_CONTACT_EMAIL',
  PROFILE_POPUP_CONTACT_MOBILE_PHONE:
    'COMMON_PROFIL_POPUP_CONTACT_MOBILE_PHONE',
  PROFILE_POPUP_CONTACT_JOB_PHONE: 'COMMON_PROFIL_POPUP_CONTACT_JOB_PHONE',

  SCROLLABLE_CONTAINER_PREVIOUS_ARROW_ALT_TEXT:
    'COMMON_SCROLLABLE_CONTAINER_PREVIOUS_ARROW_ALT_TEXT',
  SCROLLABLE_CONTAINER_NEXT_ARROW_ALT_TEXT:
    'COMMON_SCROLLABLE_CONTAINER_NEXT_ARROW_ALT_TEXT',
};
